import { render, staticRenderFns } from "./CreateView.vue?vue&type=template&id=94f95cb4&scoped=true&"
import script from "./CreateView.vue?vue&type=script&lang=js&"
export * from "./CreateView.vue?vue&type=script&lang=js&"
import style0 from "./CreateView.vue?vue&type=style&index=0&id=94f95cb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f95cb4",
  null
  
)

component.options.__file = "CreateView.vue"
export default component.exports